export interface IImpersonatableUser {
  id: number
  userName: string
  firstName: string
  lastName: string
  roleName: string
  fullName?: string // used in frontend
  displayName?: string // used in frontend
}

export interface ICompany {
  id: number
  customerNr: string
  name: string
  isActive: boolean
  lastLoggedInDate: string
  createdDate: string
}

export enum PageNames {
  Companies = 'companies',
  CreatePassword = 'create-password',
  Dashboard = 'dashboard',
  Documents = 'documents',
  Impersonate = 'impersonate',
  Login = 'login',
  LoginSupport = 'login-support',
  MyEnvironment = 'my-environment',
  Notifications = 'notifications',
  PortalSupport = 'portal-support',
  Profile = 'profile',
  RequestPassword = 'request-password',
  SetCompany = 'set-company',
  UserManagement = 'user-management',
  Users = 'users'
}
